import { FC } from 'react'

import { TextButton } from 'ui/components/Buttons'
import { Icon, IconFace, IconName, IconSize } from 'ui/components/Icon'

import { s } from './styles'

interface WidgetHeaderProps {
  expanded: boolean
  displayedProgress: number
  hasErrorsOnly: boolean
  showSuccessState: boolean
  showCancelledState: boolean
  isFadingOut: boolean
  instantReset: boolean
  activeCount: number
  totalCount: number
  onToggle: () => void
  onCancelAll: () => void
  onClose: () => void
}

export const WidgetHeader: FC<WidgetHeaderProps> = ({
  expanded,
  displayedProgress,
  hasErrorsOnly,
  showSuccessState,
  showCancelledState,
  isFadingOut,
  instantReset,
  activeCount,
  totalCount,
  onToggle,
  onCancelAll,
  onClose
}) => (
  <s.WidgetHeader
    $progress={displayedProgress}
    $hasErrors={hasErrorsOnly}
    $allSuccess={showSuccessState}
    $isFadingOut={isFadingOut}
    $instantReset={instantReset}
    onClick={onToggle}
  >
    <s.HeaderLeft>
      <s.IconWrapper>
        <Icon name={expanded ? IconName.EXPAND_MORE : IconName.EXPAND_LESS} size={IconSize.M} face={IconFace.BLACK} />
      </s.IconWrapper>
      {showSuccessState ? (
        <s.IconWrapper>
          <Icon name={IconName.CHECK_GREEN} size={IconSize.M} />
        </s.IconWrapper>
      ) : hasErrorsOnly ? (
        <s.IconWrapper>
          <Icon name={IconName.EXCLAMATION} size={IconSize.M} />
        </s.IconWrapper>
      ) : showCancelledState ? (
        <s.IconWrapper>
          <Icon name={IconName.EXCLAMATION_ORANGE} size={IconSize.M} />
        </s.IconWrapper>
      ) : (
        <s.IconWrapper>
          <Icon name={IconName.UPLOAD_ALT} size={IconSize.M} face={IconFace.BLACK} />
        </s.IconWrapper>
      )}

      <s.HeaderTitle>
        {showSuccessState ? (
          <>Upload successful</>
        ) : hasErrorsOnly ? (
          <>Uploading Error</>
        ) : showCancelledState ? (
          <>Uploading Warning</>
        ) : (
          <>
            Uploading {activeCount} of {totalCount} item{totalCount !== 1 ? 's' : ''}
          </>
        )}
      </s.HeaderTitle>
    </s.HeaderLeft>
    {showSuccessState || hasErrorsOnly || showCancelledState ? (
      <s.CloseButton
        onClick={(e) => {
          e.stopPropagation()
          onClose()
        }}
      >
        <Icon name={IconName.CROSS_SMALL} size={IconSize.M} face={IconFace.DEFAULT} />
      </s.CloseButton>
    ) : (
      <TextButton
        onClick={(e) => {
          e.stopPropagation()
          onCancelAll()
        }}
      >
        Cancel
      </TextButton>
    )}
  </s.WidgetHeader>
)
